import { historyCs } from '@/features/vehicle-history/i18n'
import { statisticsGuideCs } from '@/features/network-statistics/guideI18n'
import { routeStatisticsCs } from '@/features/route-statistics/i18n'
import { journeyPlannerCs } from '@/features/journey-planner/i18n'

export const cs = {
  app: {
    slogan: 'MHD pro lidi. Data pro nerdy.',
  },
  common: {
    close: 'Zavřít',
    retry: 'Zkusit znovu',
    refresh: 'Aktualizovat',
    loading: 'Načítám…',
    minutesShort: '{count} min',
    now: 'teď',
    yes: 'Ano',
  },
  toolbar: {
    themeLight: 'Použít světlý vzhled',
    themeDark: 'Použít tmavý vzhled',
    language: 'Přepnout do angličtiny',
    statistics: 'Statistiky',
    statisticsMenu: 'Nabídka statistik',
    networkStatistics: 'Síť',
    networkStatisticsDescription: 'Vytížení a zpoždění jednotlivých úseků',
    routeStatistics: 'Linky',
    routeStatisticsDescription: 'Spolehlivost, provoz a délka linek',
  },
  activeVehicles: {
    navigation: 'Hlavní navigace',
    navigationLabel: 'Aktivní vozy',
    map: 'Mapa',
    backToMap: 'Zpět na mapu',
    liveOverview: 'Živý provoz',
    title: 'Aktivní vozidla podle linek',
    description: 'Všechny právě jedoucí vozy na jednom místě – typ, směr, poslední známá poloha, zpoždění a čerstvost dat.',
    vehicleCount: 'Aktivních vozidel: {count}',
    routeVehicleCount: 'Vozidel na lince: {count}',
    updated: 'Data {age}',
    loading: 'Načítám aktivní vozidla…',
    loadError: 'Aktivní vozidla se teď nepodařilo načíst.',
    refreshError: 'Aktualizace se nezdařila. Zobrazujeme poslední známá data.',
    empty: 'Teď nejsou dostupná žádná aktivní vozidla.',
    emptyHint: 'Jakmile se objeví čerstvá data o vozidle na lince, uvidíte ho tady.',
    vehicle: 'Vozidlo',
    vehicleModel: 'Typ vozu',
    direction: 'Směr',
    lastPosition: 'Poslední poloha',
    delay: 'Zpoždění',
    freshness: 'Aktualizace',
    directionBetween: '{origin} → {destination}',
    directionTo: 'směr {destination}',
    directionUnknown: 'Směr není známý',
    coordinates: '{latitude}, {longitude}',
    delayUnknown: 'bez údajů',
    openVehicle: 'Otevřít vůz {number} na lince {route} na mapě',
    openStaleVehicle: 'Otevřít vůz {number} na lince {route} na mapě; poloha je zastaralá',
    stalePosition: 'Zastaralá poloha',
    filterLabel: 'Filtrovat podle druhu dopravy',
    filterMode: '{mode}: {count} aktivních vozidel',
    filteredEmpty: 'Žádná vozidla neodpovídají zvolenému filtru.',
    filteredEmptyHint: 'Zvolte jiný druh dopravy nebo znovu zobrazte všechna vozidla.',
    showAll: 'Zobrazit vše',
  },
  journeys: journeyPlannerCs,
  statistics: {
    navigationLabel: 'Statistiky sítě',
    backToMap: 'Zpět na mapu',
    eyebrow: 'Analýza sítě',
    title: 'Statistiky úseků',
    description: 'Provoz, zpoždění, změny proti předchozímu období, směrová nerovnováha i spolehlivost dat nad jedním schématem.',
    metric: 'Metrika',
    metric_passages: 'Průjezdy',
    metric_routes: 'Počet linek',
    metric_passagesPerRoute: 'Průjezdy na linku',
    metric_hourlyPeak: 'Hodinová špička',
    metric_trafficChange: 'Změna provozu',
    metric_directionalImbalance: 'Směrová nerovnováha',
    metric_delayIncrease: 'Nárůst zpoždění',
    metric_delayRecovery: 'Dohánění zpoždění',
    metric_delayImpact: 'Čistý dopad zpoždění',
    metric_delayPersistence: 'Přetrvávající zpoždění',
    metric_delayChange: 'Změna zpoždění',
    metric_criticality: 'Kritičnost úseku',
    metric_delayVariability: 'Kolísání zpoždění',
    metric_travelTime: 'Jízdní doba',
    metric_headwayIrregularity: 'Nepravidelnost intervalů',
    metric_bunching: 'Vláčkování spojů',
    metric_dataConfidence: 'Spolehlivost dat',
    help_passages: 'Celkový počet zaznamenaných průjezdů v daném směru.',
    help_routes: 'Počet různých linek, které úsek v daném směru použily.',
    help_passagesPerRoute: 'Průměrný počet průjezdů připadající na jednu linku.',
    help_hourlyPeak: 'Nejsilnější místní hodina podle průměrného počtu průjezdů za den.',
    help_trafficChange: 'Procentní změna průjezdů proti bezprostředně předchozímu stejně dlouhému období.',
    help_directionalImbalance: 'Rozdíl provozu mezi oběma směry stejného úseku.',
    help_delayIncrease: 'Průměrný nárůst zpoždění mezi sousedními zastávkami.',
    help_delayRecovery: 'Úseky, na kterých spoje v průměru zpoždění snižují.',
    help_delayImpact: 'Čistý součet změn zpoždění ze všech použitelných vzorků.',
    help_delayPersistence: 'Podíl dnů, kdy na úseku v průměru zpoždění narůstalo.',
    help_delayChange: 'Změna průměrného nabírání zpoždění proti předchozímu stejně dlouhému období.',
    help_criticality: 'Kombinace intenzity provozu a průměrného nárůstu zpoždění.',
    help_delayVariability: 'Směrodatná odchylka průměrné denní změny zpoždění.',
    help_travelTime: 'Průměrný skutečný čas od odjezdu z první zastávky do příjezdu na druhou.',
    help_headwayIrregularity: 'Variační koeficient skutečných rozestupů spojů stejné linky a hodiny; vyšší znamená méně pravidelný provoz.',
    help_bunching: 'Podíl spojů, jejichž skutečný rozestup je nejvýše polovina plánovaného rozestupu.',
    help_dataConfidence: 'Skóre pokrytí dnů a dostatečného počtu vzorků zpoždění.',
    period: 'Období',
    period_today: 'Dnes',
    period_7d: '7 dní',
    period_28d: '28 dní',
    period_90d: '90 dní',
    ranking: 'Pořadí úseků',
    segmentCount: '{count} úseků',
    loading: 'Počítám statistiky úseků…',
    loadError: 'Statistiky se teď nepodařilo načíst.',
    empty: 'Pro zvolené období nejsou dostupná data.',
    emptyRange: 'Pro období {from}–{to} nejsou dostupná agregovaná data.',
    emptyPartial: 'Zdroj označil toto období jako neúplné.',
    show28d: 'Zobrazit 28 dní',
    lines: 'Linky:',
    routeValue: '{count} linek',
    passageValue: '{count} průjezdů',
    passagesPerRouteValue: '{count} / linku',
    hourlyPeakValue: '{count}/h · {hour}',
    segmentDetail: 'Detail úseku',
    passages: 'Průjezdy',
    routes: 'Linky',
    delayIncrease: 'Prům. změna',
    samples: 'Vzorky zpoždění',
    totalDelayImpact: 'Čistý dopad',
    problemDays: 'Dny s nárůstem',
    previousPeriod: 'Proti min. období',
    reversePassages: 'Opačný směr',
    observedDays: 'Pokryté dny',
    variability: 'Kolísání',
    peakHour: 'Špičková hodina',
    averageHourlyPassages: 'Prům. průjezdů/h',
    travelTime: 'Jízdní doba',
    travelTimeSamples: 'Vzorky jízdní doby',
    headwayIrregularity: 'Nepravidelnost',
    headwaySamples: 'Vzorky rozestupů',
    bunching: 'Slepené spoje',
    routeBreakdown: 'Rozklad podle linek',
    route: 'Linka',
    partialData: 'Období obsahuje neúplný nebo dosud neuzavřený provozní den.',
    legend: 'Intenzita zvolené metriky',
    legendLow: 'méně',
    legendHigh: 'více',
    legendDecrease: 'pokles',
    legendIncrease: 'nárůst',
    legendImprovement: 'zlepšení',
    legendWorsening: 'zhoršení',
    segmentAria: 'Úsek {from} až {to}',
    guideLink: 'Jak statistiky fungují',
    guideLinkAria: 'Zjistit, jak statistiky fungují (otevře se v nové kartě)',
  },
  statisticsGuide: statisticsGuideCs,
  routeStatistics: routeStatisticsCs,
  search: {
    loading: 'Hledám v celé síti…', error: 'Hledání v celé síti se nepodařilo. Zkuste zadat dotaz znovu.', realtimeUnavailable: 'Aktuální polohy vozů nejsou dostupné. Výsledky obsahují pouze zastávky.',
    label: 'Hledat spoj nebo zastávku',
    placeholder: 'Linka, zastávka nebo vůz…',
    clear: 'Vymazat hledání',
    routes: 'Linky',
    stops: 'Zastávky',
    vehicles: 'Vozidla',
    routeDescription: 'Linka {route}',
    vehicleDescription: 'Evidenční číslo {number}',
    noResults: 'V aktuálním výřezu jsme nic nenašli.',
    hint: 'Hledejte číslo linky, zastávku nebo evidenční číslo.',
  },
  filters: {
    label: 'Druhy dopravy',
    show: 'Zobrazit filtry',
    all: 'Vše',
    clear: 'Zrušit filtry',
  },
  modes: {
    tram: 'Tramvaje',
    bus: 'Autobusy',
    trolleybus: 'Trolejbusy',
    metro: 'Metro',
    train: 'Vlaky',
    ferry: 'Přívozy',
    funicular: 'Lanovky',
    unknown: 'Ostatní',
  },
  modeSingular: {
    tram: 'Tramvaj',
    bus: 'Autobus',
    trolleybus: 'Trolejbus',
    metro: 'Metro',
    train: 'Vlak',
    ferry: 'Přívoz',
    funicular: 'Lanovka',
    unknown: 'Vozidlo',
  },
  status: {
    live: 'Živá data',
    refreshing: 'Aktualizuji',
    updatedNow: 'Aktualizováno právě teď',
    updatedAgo: 'Aktualizováno před {time}',
    ageSeconds: '{count} s',
    ageMinutes: '{count} min',
    ageHours: '{count} h',
    stale: 'Data jsou zastaralá',
    providerError: 'Aktuální data teď nejsou dostupná. Zobrazujeme poslední známou polohu.',
    offline: 'Jste offline. Poslední známá data zůstávají na mapě.',
    noSnapshot: 'Čekáme na první dopravní snapshot.',
  },
  map: {
    label: 'Mapa živé veřejné dopravy',
    viewSwitchLabel: 'Zobrazení mapy',
    classicView: 'Klasická mapa',
    schematicView: 'Schéma',
    servicePeriodLabel: 'Provoz linek',
    dayService: 'Denní',
    nightService: 'Noční',
    schematicModeLabel: 'Druh dopravy ve schématu',
    allTransportModes: 'Vše',
    loading: 'Připravuji mapu a živá data…',
    empty: 'V tomto výřezu nejsou žádná vozidla pro zvolené filtry.',
    tilesError: 'Mapový podklad se nepodařilo načíst.',
    tilesFallback: 'Dopravní data můžete dál procházet bez mapového podkladu.',
    recenter: 'Zaměřit vybrané místo',
    vehicleLabel: 'Linka {route}, směr {headsign}',
    stopLabel: 'Zastávka {name}',
    overlapTitle: '{count} objektů v tomto místě',
    overlapHint: 'Najetím objekt zvýrazníte. Alt+klik nebo Tab je postupně vybírá.',
    overlapVehicle: 'Linka {route}',
    overlapVehicleMeta: 'Vůz {number} · směr {headsign}',
    overlapStopMeta: 'Zastávka',
    schematicLabel: 'Schéma sítě veřejné dopravy',
    schematicLoading: 'Připravuji schéma dopravní sítě…',
    schematicError: 'Schéma sítě se teď nepodařilo načíst.',
    schematicEmpty: 'Pro zvolené období a druhy dopravy není ve schématu žádná linka.',
    schematicFallback: 'Zobrazit klasickou mapu',
    schematicZoomIn: 'Přiblížit schéma',
    schematicZoomOut: 'Oddálit schéma',
    schematicBasemap: 'Mapový podklad pod schématem',
    schematicRouteBadge: 'Linka {route} z konečné {stop}',
  },
  nearby: {
    showLocation: 'Zobrazit moji polohu',
    showStops: 'Zobrazit zastávky v okolí',
    eyebrow: 'Podle vaší polohy',
    title: 'Zastávky v okolí',
    description: 'Nejbližší zastávky do 1,5 km. Rozbalte zastávku pro odjezdy podle nástupišť.',
    locating: 'Zjišťuji vaši polohu…',
    locatingHint: 'Prohlížeč se může zeptat na povolení přístupu k poloze.',
    loading: 'Hledám nejbližší zastávky…',
    unsupported: 'Tento prohlížeč neumí zjistit polohu.',
    permissionDenied: 'Přístup k poloze není povolený.',
    timeout: 'Polohu se nepodařilo zjistit včas.',
    unavailable: 'Vaši polohu se teď nepodařilo zjistit.',
    locationErrorHint: 'Zkontrolujte oprávnění k poloze v nastavení prohlížeče a zkuste to znovu.',
    loadError: 'Zastávky v okolí se nepodařilo načíst.',
    empty: 'V okolí jsme nenašli žádnou zastávku.',
    emptyHint: 'Zkuste polohu znovu načíst nebo se přesuňte na jiné místo.',
    platformCount: 'Nástupiště a stanoviště: {count}',
    loadingDepartures: 'Načítám odjezdy podle nástupišť…',
    departuresError: 'Odjezdy pro tuto zastávku se nepodařilo načíst.',
    platform: 'Nástupiště {platform}',
    onlyPlatform: 'Odjezdy ze zastávky',
    unnamedPlatform: 'Stanoviště {number}',
    openPlatform: 'Otevřít detail: {platform}',
    openFullDetail: 'Otevřít všechny nejbližší spoje',
    platformDeparturesError: 'Odjezdy pro toto stanoviště nejsou dostupné.',
    distanceMeters: '{distance} m',
    distanceKilometers: '{distance} km',
  },
  detail: {
    backToStopView: 'Zpět k zastávkovému zobrazení',
    expand: 'Rozbalit detail',
    collapse: 'Sbalit detail',
    focusVehicle: 'Zaměřit aktuální polohu vozidla',
    loadingVehicle: 'Načítám detail vozidla a jeho trasu…',
    loadingStop: 'Načítám zastávku a odjezdy…',
    loadingTrip: 'Načítám detail spoje a jeho trasu…',
    vehicleNotFound: 'Vozidlo už v aktuálním snapshotu není.',
    stopNotFound: 'Zastávku se nepodařilo najít.',
    tripNotFound: 'Spoj se nepodařilo najít.',
    loadError: 'Detail se teď nepodařilo načíst.',
    vehicle: 'Vozidlo',
    stop: 'Zastávka',
    trip: 'Spoj',
    departure: 'Odjezd',
    stopPlatform: 'Nástupiště',
    accessibility: 'Přístupnost',
    direction: 'směr {headsign}',
    registration: 'Vůz {number}',
    model: 'Typ vozu',
    operator: 'Dopravce',
    delay: 'Zpoždění',
    early: 'Náskok {minutes} min',
    onTime: 'Včas',
    delayed: '+{minutes} min',
    lastStop: 'Poslední zastávka',
    nextStop: 'Následující zastávka',
    positionAge: 'Poloha',
    speed: 'Rychlost',
    speedValue: '{speed} km/h',
    route: 'Průběh spoje',
    routeUnavailable: 'Konkrétní průběh trasy není k dispozici.',
    passedStop: 'projetá zastávka',
    nextRouteStop: 'následující zastávka',
    remainingStop: 'zbývající zastávka',
    equipment: 'Výbava',
    wheelchair: 'Bezbariérové',
    airConditioned: 'Klimatizace',
    usbChargers: 'USB nabíjení',
    staleVehicle: 'Poloha tohoto vozidla je zastaralá.',
    cancelled: 'Spoj je zrušený',
    platform: 'stanoviště {platform}',
    departures: 'Nejbližší odjezdy',
    noDepartures: 'V nejbližší době nejsou žádné odjezdy.',
    timetableOnly: 'U těchto odjezdů je dostupný pouze jízdní řád.',
    realtime: 'živá predikce',
    scheduled: 'jízdní řád',
    departureCancelled: 'zrušeno',
    accessible: 'bezbariérový spoj',
    exactTime: '{time} · {source}',
    predictionOnTime: 'Predikce {time}, spoj jede včas',
    predictionOffSchedule: 'Predikce {time}, spoj má odchylku od jízdního řádu',
    openTrip: 'Otevřít detail spoje linky {route} směrem {headsign}',
    nextStops: 'Dále přes',
    followingStopsAria: 'Následující zastávky spoje směrem {headsign}',
  },
  history: historyCs,
}
